// Product Form JavaScript - extracted from product-form.liquid snippet
// This file contains all the variant selection and form handling logic

function onVariantChange(event) {
  console.log('onVariantChange');
  console.log('event: ', event);
  const productElement = event.target.closest('#product');
  const sectionId = productElement.dataset.sectionId;
  const optionValueSelectors = productElement.querySelector('.optionValueSelectors');

  console.log(
    'onVariantChange - product element context:',
    productElement.closest('.product-popover') ? 'popover' : 'main-page',
  );
  console.log('onVariantChange - section ID:', sectionId);

  // Update variant selection immediately when user selects an option
  // (Only do this if we're going to skip the fetch, otherwise wait for after fetch)
  if (event.target.dataset.autoSelected && event.target.dataset.pageLoad) {
    updateVariantSelection();
    updateButtonState();
  }

  // Only skip fetch for page load auto-selection, not for auto-switches during variant changes
  if (event.target.dataset.autoSelected && event.target.dataset.pageLoad) {
    console.log('Page load auto-selection event, skipping fetch');
    delete event.target.dataset.autoSelected;
    delete event.target.dataset.pageLoad;
    return;
  }

  // Clean up any remaining flags
  if (event.target.dataset.autoSelected) {
    console.log('Auto-selection during variant change, proceeding with fetch');
    delete event.target.dataset.autoSelected;
  }
  if (event.target.dataset.needsRefresh) {
    delete event.target.dataset.needsRefresh;
  }

  // Combined listings: We use old and new product urls to determine if the product should change
  const oldProductUrl = productElement.dataset.productUrl;
  const newProductUrl = event.target.dataset.productUrl;

  console.log('URL values:', { oldProductUrl, newProductUrl, eventTargetId: event.target.id });

  // Use oldProductUrl as fallback if newProductUrl is not set
  const fetchUrl = newProductUrl || oldProductUrl;

  if (!fetchUrl) {
    console.error('No product URL available for fetching');
    return;
  }

  // Get the selected option value IDs and format as query param
  const selectedOptionValues = Array.from(optionValueSelectors.querySelectorAll('fieldset input:checked')).map(
    ({ dataset }) => dataset.optionValueId,
  );
  const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : '';

  console.log('Fetching with params:', params, 'from URL:', fetchUrl);

  // Determine the correct section ID to use for fetching
  // For popover contexts, we need to fetch from the main product page structure
  const isPopoverContext = productElement.closest('.product-popover');
  let fetchSectionId = sectionId;

  if (isPopoverContext) {
    // For popover, we need to fetch the product form structure from the main product page
    // Use section rendering to get updated availability state
    console.log('Popover context detected - fetching from main product page with section rendering');

    // We need to fetch the main-product section with the option values to get updated availability
    fetch(`${fetchUrl}?section_id=main-product${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Combined listings: If the product changed, replace the old product section with the new product section
        if (newProductUrl && oldProductUrl !== newProductUrl) {
          const newProductSection = html.querySelector('#product');
          if (newProductSection) {
            productElement.parentNode.insertBefore(newProductSection, productElement);
            productElement.remove();
            // Focus the input for the last clicked option value
            const focusElement = document.querySelector(`#${event.target.id}`);
            if (focusElement) {
              focusElement.focus();
            }
          }
          return;
        }

        // Extract the product section from the main product page section rendering
        console.log('Section rendering response length:', responseText.length);
        console.log('Response contains #product:', responseText.includes('id="product"'));
        console.log('Response contains optionValueSelectors:', responseText.includes('optionValueSelectors'));

        const newProductSection = html.querySelector('#product');
        console.log('Found product section in response:', !!newProductSection);

        if (newProductSection) {
          console.log('Product section HTML preview:', newProductSection.outerHTML.substring(0, 500) + '...');

          const newOptionsElement = newProductSection.querySelector('.optionValueSelectors');
          console.log('Found new options element from main-product section:', !!newOptionsElement);

          if (newOptionsElement) {
            console.log('New options element HTML length:', newOptionsElement.innerHTML.length);
            console.log('New options HTML preview:', newOptionsElement.innerHTML.substring(0, 200) + '...');
            console.log('New options element structure:', newOptionsElement.outerHTML.substring(0, 300) + '...');

            // Log availability states before and after update
            const oldOptions = optionValueSelectors.querySelectorAll('input[type="radio"]');
            console.log(
              'Old options availability:',
              Array.from(oldOptions).map((input) => ({
                value: input.value,
                disabled: input.disabled,
                available: input.dataset.available,
              })),
            );

            optionValueSelectors.innerHTML = newOptionsElement.innerHTML;

            const newOptions = optionValueSelectors.querySelectorAll('input[type="radio"]');
            console.log(
              'New options availability:',
              Array.from(newOptions).map((input) => ({
                value: input.value,
                disabled: input.disabled,
                available: input.dataset.available,
              })),
            );

            // Also update the quantity limit element if it exists in the response
            const newQuantityLimitElement =
              newProductSection.querySelector('[data-product-quantity-limit]') ||
              html.querySelector('[data-product-quantity-limit]');
            const existingQuantityLimitContainer = productElement
              .closest('.product-popover')
              .querySelector('.product-popover__quantity-limit');

            console.log('Quantity limit update check:', {
              hasNewQuantityLimit: !!newQuantityLimitElement,
              hasExistingContainer: !!existingQuantityLimitContainer,
              newQuantityLimitValue: newQuantityLimitElement?.dataset.productQuantityLimit,
              searchedInProductSection: !!newProductSection.querySelector('[data-product-quantity-limit]'),
              searchedInEntireResponse: !!html.querySelector('[data-product-quantity-limit]'),
            });

            if (newQuantityLimitElement) {
              if (existingQuantityLimitContainer) {
                // Update existing quantity limit element
                existingQuantityLimitContainer.innerHTML = newQuantityLimitElement.outerHTML;
                console.log('Updated quantity limit element in popover');
              } else {
                // Create new quantity limit container if it doesn't exist
                const formContainer = productElement
                  .closest('.product-popover')
                  .querySelector('.product-popover__form');
                if (formContainer) {
                  // Look for the wrapper div first
                  let wrapperDiv = formContainer.querySelector('.mt-l.flex.flex-col.gap-xs.justify-center');

                  if (!wrapperDiv) {
                    // Create the wrapper div if it doesn't exist
                    wrapperDiv = document.createElement('div');
                    wrapperDiv.className = 'mt-l flex flex-col gap-xs justify-center';
                    formContainer.appendChild(wrapperDiv);
                  }

                  const quantityLimitDiv = document.createElement('div');
                  quantityLimitDiv.className = 'product-popover__quantity-limit text-center';
                  quantityLimitDiv.innerHTML = newQuantityLimitElement.outerHTML;

                  // Insert at the beginning of the wrapper div
                  wrapperDiv.insertBefore(quantityLimitDiv, wrapperDiv.firstChild);
                  console.log('Created new quantity limit element in popover wrapper');
                }
              }
            } else if (existingQuantityLimitContainer) {
              // Remove quantity limit if it no longer exists in the response
              existingQuantityLimitContainer.remove();
              console.log('Removed quantity limit element from popover (not in response)');
            }

            // Also update the price element if it exists in the response
            const newPriceElement =
              newProductSection.querySelector('#ProductPrice, .product--pricing, .price') ||
              html.querySelector('#ProductPrice, .product--pricing, .price');
            const existingPriceContainer = productElement
              .closest('.product-popover')
              .querySelector('.product-popover__price');

            console.log('Price update check:', {
              hasNewPrice: !!newPriceElement,
              hasExistingPriceContainer: !!existingPriceContainer,
              searchedInProductSection: !!newProductSection.querySelector('#ProductPrice, .product--pricing, .price'),
              searchedInEntireResponse: !!html.querySelector('#ProductPrice, .product--pricing, .price'),
            });

            if (newPriceElement && existingPriceContainer) {
              // Update existing price element
              existingPriceContainer.innerHTML = newPriceElement.outerHTML;
              console.log('Updated price element in popover');
            } else if (newPriceElement && !existingPriceContainer) {
              // Create new price container if it doesn't exist
              const infoContainer = productElement
                .closest('.product-popover')
                .querySelector('.product-popover__info .flex.flex-row.gap-xl');
              if (infoContainer) {
                const priceDiv = document.createElement('div');
                priceDiv.className = 'product-popover__price';
                priceDiv.innerHTML = newPriceElement.outerHTML;
                infoContainer.appendChild(priceDiv);
                console.log('Created new price element in popover');
              }
            }

            console.log('Updated options in popover context from main-product section with availability');
          } else {
            console.error('No .optionValueSelectors found in main-product section response');
            console.log(
              'Available selectors in response:',
              Array.from(newProductSection.querySelectorAll('*'))
                .map((el) => el.className)
                .filter((c) => c),
            );
            console.log('Response preview:', responseText.substring(0, 500) + '...');

            // Fallback: Try to find options in the entire response
            const fallbackOptionsElement = html.querySelector('.optionValueSelectors');
            if (fallbackOptionsElement) {
              console.log('Found options element via fallback selector in entire response');
              optionValueSelectors.innerHTML = fallbackOptionsElement.innerHTML;

              // Also try to update quantity limit element via fallback
              const fallbackQuantityLimitElement = html.querySelector('[data-product-quantity-limit]');
              const existingQuantityLimitContainer = productElement
                .closest('.product-popover')
                .querySelector('.product-popover__quantity-limit');

              if (fallbackQuantityLimitElement && existingQuantityLimitContainer) {
                existingQuantityLimitContainer.innerHTML = fallbackQuantityLimitElement.outerHTML;
                console.log('Updated quantity limit element via fallback (entire response)');
              }

              // Also try to update price element via fallback
              const fallbackPriceElement = html.querySelector('#ProductPrice, .product--pricing, .price');
              const existingPriceContainer = productElement
                .closest('.product-popover')
                .querySelector('.product-popover__price');

              if (fallbackPriceElement && existingPriceContainer) {
                existingPriceContainer.innerHTML = fallbackPriceElement.outerHTML;
                console.log('Updated price element via fallback (second case)');
              }
            }
          }
        } else {
          console.error('No #product section found in main-product section response');
          console.log(
            'Available elements in response:',
            Array.from(html.querySelectorAll('*'))
              .map((el) => el.tagName + (el.id ? '#' + el.id : '') + (el.className ? '.' + el.className : ''))
              .slice(0, 10),
          );
          console.log('Full response preview:', responseText.substring(0, 1000) + '...');

          // Fallback: Try to find options in the entire response
          const fallbackOptionsElement = html.querySelector('.optionValueSelectors');
          if (fallbackOptionsElement) {
            console.log('Found options element via fallback selector in entire response');
            optionValueSelectors.innerHTML = fallbackOptionsElement.innerHTML;

            // Also try to update quantity limit element via fallback
            const fallbackQuantityLimitElement = html.querySelector('[data-product-quantity-limit]');
            const existingQuantityLimitContainer = productElement
              .closest('.product-popover')
              .querySelector('.product-popover__quantity-limit');

            if (fallbackQuantityLimitElement && existingQuantityLimitContainer) {
              existingQuantityLimitContainer.innerHTML = fallbackQuantityLimitElement.outerHTML;
              console.log('Updated quantity limit element via fallback (entire response)');
            }
          }
        }

        // Re-attach event listeners to the new inputs first
        attachVariantChangeListeners();

        // Re-attach sidebar event listeners for size chart buttons
        if (window.sidebar && typeof window.sidebar.bindEvents === 'function') {
          window.sidebar.bindEvents();
        }

        // Check if currently selected options are still available and switch to next available if needed
        ensureValidSelection(productElement);

        // Update variant selection and URL - use setTimeout to ensure DOM updates complete
        setTimeout(() => {
          console.log('Updating after section refresh (popover)');
          updateVariantSelection();
          updateButtonState();
        }, 10);

        const focusElement = document.querySelector(`#${event.target.id}`);
        if (focusElement) {
          focusElement.focus();
        }
      })
      .catch((error) => {
        console.error('Error in onVariantChange fetch (popover):', error);
      });

    return; // Exit early for popover context
  }

  // Original logic for main page context
  // Deferred variants: Fetch the option value picker with the new availability state when remaining on the same product
  // Combined listings: Fetch the product associated with the selected option value and replace the entire product if switching to a sibling product
  fetch(`${fetchUrl}?section_id=${fetchSectionId}${params}`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      // Combined listings: If the product changed, replace the old product section with the new product section
      if (newProductUrl && oldProductUrl !== newProductUrl) {
        productElement.parentNode.insertBefore(html.querySelector('#product'), productElement);
        productElement.remove();
        // Focus the input for the last clicked option value
        const focusElement = document.querySelector(`#${event.target.id}`);
        if (focusElement) {
          focusElement.focus();
        }
        return;
      }

      // Update the option value selectors with new availability
      const newOptionsElement = html.querySelector('.optionValueSelectors');
      console.log('Found new options element:', !!newOptionsElement);
      if (newOptionsElement) {
        console.log('New options HTML preview:', newOptionsElement.innerHTML.substring(0, 200) + '...');
        optionValueSelectors.innerHTML = newOptionsElement.innerHTML;
        console.log(
          'Updated options in context:',
          productElement.closest('.product-popover') ? 'popover' : 'main-page',
        );
      } else {
        console.error('No .optionValueSelectors found in response');
        console.log('Response preview:', responseText.substring(0, 500) + '...');
      }

      // Update the price element for main product page
      const newPriceElement = html.querySelector('#ProductPrice');
      const existingPriceElement = document.querySelector('#ProductPrice');

      console.log('Main page price update check:', {
        hasNewPrice: !!newPriceElement,
        hasExistingPrice: !!existingPriceElement,
      });

      if (newPriceElement && existingPriceElement) {
        existingPriceElement.innerHTML = newPriceElement.innerHTML;
        console.log('Updated price element on main product page');
      }

      // Re-attach event listeners to the new inputs first
      attachVariantChangeListeners();

      // Re-attach sidebar event listeners for size chart buttons
      if (window.sidebar && typeof window.sidebar.bindEvents === 'function') {
        window.sidebar.bindEvents();
      }

      // Check if currently selected options are still available and switch to next available if needed
      ensureValidSelection(productElement);

      // Update variant selection and URL - use setTimeout to ensure DOM updates complete
      setTimeout(() => {
        console.log('Updating after section refresh');
        updateVariantSelection();
        updateButtonState();
      }, 10);

      const focusElement = document.querySelector(`#${event.target.id}`);
      if (focusElement) {
        focusElement.focus();
      }

      // Update any other sections that depend on the option value picker
    })
    .catch((error) => {
      console.error('Error in onVariantChange fetch:', error);
    });
}

function ensureValidSelection(specificProductElement = null) {
  // Find the product element that was just updated (in case there are multiple on the page)
  // If a specific element is provided, use that; otherwise, try to find it
  let targetProductElement = specificProductElement;

  if (!targetProductElement) {
    // Check if there's an active element that can help us identify the right product
    const activeElement = document.activeElement;
    if (activeElement && activeElement.closest('#product')) {
      targetProductElement = activeElement.closest('#product');
      console.log('ensureValidSelection - found via active element');
    }
  }

  // If not found via active element, look for elements with auto-selected inputs
  if (!targetProductElement) {
    const allProductElements = document.querySelectorAll('#product');

    for (const element of allProductElements) {
      const inputs = element.querySelectorAll('.optionValueSelectors input[type="radio"]');
      if (inputs.length > 0) {
        // Check if any inputs have the recently updated class
        const hasRecentUpdate = Array.from(inputs).some((input) => input.dataset.autoSelected);
        if (hasRecentUpdate) {
          targetProductElement = element;
          console.log('ensureValidSelection - found via auto-selected inputs');
          break;
        }
      }
    }
  }

  // Fallback to first product element
  if (!targetProductElement) {
    targetProductElement = document.querySelector('#product');
    console.log('ensureValidSelection - using fallback (first element)');
  }

  console.log(
    'ensureValidSelection - using product element:',
    targetProductElement.id || 'no-id',
    'in context:',
    targetProductElement.closest('.product-popover') ? 'popover' : 'main-page',
  );

  // Skip for single variant products
  const defaultVariantInput = targetProductElement.querySelector('input[id$="-default-variant"]');
  if (defaultVariantInput) {
    console.log('Single variant product - skipping ensureValidSelection');
    return;
  }

  const fieldsets = targetProductElement.querySelectorAll('.optionValueSelectors fieldset');
  console.log('Found', fieldsets.length, 'fieldsets in product element');

  let needsCascadingUpdate = false;
  let lastUpdatedInput = null;

  fieldsets.forEach((fieldset, index) => {
    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    const availableInput = fieldset.querySelector('input[type="radio"]:not([disabled])');

    console.log(`Fieldset ${index}:`, {
      hasCheckedInput: !!checkedInput,
      checkedInputDisabled: checkedInput?.disabled,
      hasAvailableInput: !!availableInput,
      checkedValue: checkedInput?.value,
      availableValue: availableInput?.value,
    });

    // If the currently selected option is disabled, or no option is selected but available options exist
    if ((checkedInput && checkedInput.disabled) || (!checkedInput && availableInput)) {
      // First, uncheck any disabled option
      if (checkedInput && checkedInput.disabled) {
        checkedInput.checked = false;
        console.log(`Unchecked disabled option: ${checkedInput.value}`);
      }

      if (availableInput) {
        // Select the first available option
        availableInput.checked = true;
        console.log(`Auto-selected available option: ${availableInput.value} in fieldset ${index}`);

        // Mark as auto-selected but DON'T mark as pageLoad - this will allow fetch to proceed
        availableInput.dataset.autoSelected = 'true';
        needsCascadingUpdate = true;
        lastUpdatedInput = availableInput;
      }
    }
  });

  // If we made changes, trigger change event on the last updated input to cascade updates
  if (needsCascadingUpdate && lastUpdatedInput) {
    console.log(`Triggering change event for cascading update: ${lastUpdatedInput.value}`);
    // Trigger change event to update other dependent options
    const changeEvent = new Event('change', { bubbles: true });
    lastUpdatedInput.dispatchEvent(changeEvent);
  } else if (!needsCascadingUpdate) {
    // Only update if we don't have cascading updates happening
    setTimeout(() => {
      console.log('Updating after ensuring valid selection (no cascading needed)');
      updateVariantSelection();
      updateButtonState();
    }, 10);
  }
}

function updateVariantSelection() {
  console.log('updateVariantSelection called');

  // Handle multiple product elements (main page + popover)
  // Process main page first, then popover
  const allProductElements = Array.from(document.querySelectorAll('#product')).sort((a, b) => {
    const aIsPopover = !!a.closest('.product-popover');
    const bIsPopover = !!b.closest('.product-popover');
    // Main page (not popover) comes first
    if (!aIsPopover && bIsPopover) return -1;
    if (aIsPopover && !bIsPopover) return 1;
    return 0;
  });

  allProductElements.forEach((productElement, index) => {
    const isPopover = productElement.closest('.product-popover');
    console.log(`Processing product element ${index}:`, isPopover ? 'popover' : 'main-page');

    const optionValueSelectors = productElement.querySelector('.optionValueSelectors');
    if (!optionValueSelectors) {
      console.log(`No option selectors found in product element ${index}`);
      return;
    }

    // Check if this is a single variant product
    const defaultVariantInput = productElement.querySelector('input[id$="-default-variant"]');
    if (defaultVariantInput) {
      console.log('Single variant product detected');
      const variantId = defaultVariantInput.dataset.variantId;

      // Update hidden input in the existing buy-buttons form
      const hiddenVariantInput = document.querySelector('product-form.product-form input[name="id"]');
      if (hiddenVariantInput) {
        hiddenVariantInput.value = variantId;
        hiddenVariantInput.disabled = false;
      }

      // Update URL with variant parameter (only for main page, not popover)
      if (!isPopover) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }

      console.log('Updated single variant to ID:', variantId);
      return;
    }

    // Multi-variant product logic
    // Find all checked inputs to debug
    const allCheckedInputs = optionValueSelectors.querySelectorAll('input[type="radio"]:checked');
    console.log(
      `All checked inputs in element ${index}:`,
      Array.from(allCheckedInputs).map((input) => ({
        name: input.name,
        value: input.value,
        available: input.dataset.available,
        variantId: input.dataset.variantId,
        disabled: input.disabled,
        id: input.id,
      })),
    );

    // Find the selected option that has a variant from the LAST option group (most specific)
    const selectedInputsWithVariant = optionValueSelectors.querySelectorAll(
      'input[type="radio"]:checked[data-variant-id]',
    );

    console.log(
      `All inputs with variant IDs in element ${index}:`,
      Array.from(selectedInputsWithVariant).map((input) => ({
        name: input.name,
        value: input.value,
        variantId: input.dataset.variantId,
        id: input.id,
      })),
    );

    const selectedInputWithVariant = selectedInputsWithVariant[selectedInputsWithVariant.length - 1]; // Get the last one

    console.log(
      `Selected input with variant in element ${index}:`,
      selectedInputWithVariant
        ? {
            value: selectedInputWithVariant.value,
            variantId: selectedInputWithVariant.dataset.variantId,
            available: selectedInputWithVariant.dataset.available,
            disabled: selectedInputWithVariant.disabled,
          }
        : 'None found',
    );

    if (selectedInputWithVariant) {
      const variantId = selectedInputWithVariant.dataset.variantId;
      console.log(`Updating to variant ID: ${variantId} in element ${index}`);

      // Update hidden input in the existing buy-buttons form
      const hiddenVariantInput = document.querySelector('product-form.product-form input[name="id"]');
      if (hiddenVariantInput) {
        hiddenVariantInput.value = variantId;
        hiddenVariantInput.disabled = false;
      }

      // Update URL with variant parameter (only for main page, not popover)
      if (!isPopover) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }

      // Update variant data script for popover (fetch the current variant data)
      updateVariantDataScript(variantId);
    } else {
      console.log(`No selected input with variant ID found in element ${index}`);
    }
  });
}

function updateVariantDataScript(variantId) {
  // Fetch the current variant data from the product API
  const productElement = document.querySelector('#product');
  const productUrl = productElement.dataset.productUrl;

  fetch(`${productUrl}.js`)
    .then((response) => response.json())
    .then((productData) => {
      // Find the selected variant
      const selectedVariant = productData.variants.find((variant) => variant.id.toString() === variantId);

      if (selectedVariant) {
        // Update the variant data script
        const variantScript = document.querySelector('[data-selected-variant]');
        if (variantScript) {
          variantScript.textContent = JSON.stringify(selectedVariant);
          console.log('Updated variant data script with variant:', selectedVariant.title);
        }
      }
    })
    .catch((error) => {
      console.error('Error fetching variant data:', error);
    });
}

function getVariantIdFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}

function selectOptionsForVariant(variantId) {
  console.log('selectOptionsForVariant called with variant ID:', variantId);

  // Get variant data from the script tag
  const variantScript = document.querySelector('[data-selected-variant]');
  if (!variantScript) {
    console.log('No variant data script found');
    return false;
  }

  let selectedVariant;
  try {
    selectedVariant = JSON.parse(variantScript.textContent);
  } catch (e) {
    console.error('Error parsing variant data:', e);
    return false;
  }

  // Verify this is the correct variant
  if (selectedVariant.id.toString() !== variantId.toString()) {
    console.log('Variant data script does not match URL variant ID');
    return false;
  }

  console.log('Selected variant data:', selectedVariant);
  console.log('Variant options:', selectedVariant.options);

  const productElement = document.querySelector('#product');
  const fieldsets = productElement.querySelectorAll('.optionValueSelectors fieldset');

  if (fieldsets.length !== selectedVariant.options.length) {
    console.warn('Mismatch between fieldsets and variant options length');
  }

  let allOptionsSelected = true;

  // For each option position, find and select the matching radio input
  selectedVariant.options.forEach((optionValue, index) => {
    if (index >= fieldsets.length) {
      console.warn(`No fieldset found for option index ${index}`);
      return;
    }

    const fieldset = fieldsets[index];
    console.log(`Looking for option "${optionValue}" in fieldset ${index}`);

    // Find the radio input with matching value
    const matchingInput = fieldset.querySelector(`input[type="radio"][value="${optionValue}"]`);

    if (matchingInput) {
      // Uncheck all inputs in this fieldset first
      const allInputsInFieldset = fieldset.querySelectorAll('input[type="radio"]');
      allInputsInFieldset.forEach((input) => (input.checked = false));

      // Check the matching input
      matchingInput.checked = true;
      matchingInput.dataset.autoSelected = 'true';
      matchingInput.dataset.pageLoad = 'true';

      console.log(`Selected option "${optionValue}" in fieldset ${index}`);
    } else {
      console.warn(`No matching input found for option "${optionValue}" in fieldset ${index}`);
      console.log(
        'Available options in fieldset:',
        Array.from(fieldset.querySelectorAll('input[type="radio"]')).map((input) => input.value),
      );
      allOptionsSelected = false;
    }
  });

  return allOptionsSelected;
}

function ensureValidSelectionOnLoad() {
  const productElement = document.querySelector('#product');

  // Skip for single variant products
  const defaultVariantInput = productElement.querySelector('input[id$="-default-variant"]');
  if (defaultVariantInput) {
    console.log('Single variant product - skipping ensureValidSelectionOnLoad');
    return;
  }

  // Check if there's a variant parameter in the URL
  const variantIdFromUrl = getVariantIdFromUrl();

  if (variantIdFromUrl) {
    console.log('Found variant ID in URL:', variantIdFromUrl);

    // Try to select options based on the variant from URL
    const variantOptionsSelected = selectOptionsForVariant(variantIdFromUrl);

    if (variantOptionsSelected) {
      console.log('Successfully selected options based on URL variant');

      // Find the last auto-selected input to trigger change event
      const autoSelectedInputs = productElement.querySelectorAll(
        'input[data-auto-selected="true"][data-page-load="true"]',
      );
      const lastAutoSelectedInput = autoSelectedInputs[autoSelectedInputs.length - 1];

      if (lastAutoSelectedInput) {
        console.log('Triggering change event for variant-based selection');
        const changeEvent = new Event('change', { bubbles: true });
        lastAutoSelectedInput.dispatchEvent(changeEvent);
      }

      return; // Exit early since we successfully selected based on URL variant
    } else {
      console.log('Failed to select options based on URL variant, falling back to default logic');
    }
  }

  // Original fallback logic for when no URL variant or variant selection failed
  const fieldsets = productElement.querySelectorAll('.optionValueSelectors fieldset');
  let needsUpdate = false;
  let lastChangedInput = null;

  fieldsets.forEach((fieldset) => {
    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    const hasCheckedInput = checkedInput !== null;

    // If no option is selected, or if selected option is disabled, select first available
    if (!hasCheckedInput || (checkedInput && checkedInput.disabled)) {
      if (checkedInput && checkedInput.disabled) {
        checkedInput.checked = false; // Uncheck disabled option
      }

      // Find the first available option in this fieldset
      const availableInput = fieldset.querySelector('input[type="radio"]:not([disabled])');

      if (availableInput) {
        availableInput.checked = true;
        availableInput.dataset.autoSelected = 'true'; // Mark as auto-selected
        availableInput.dataset.pageLoad = 'true'; // Mark as page load selection
        needsUpdate = true;
        lastChangedInput = availableInput;
        console.log(`Auto-selected available option: ${availableInput.value}`);
      }
    }
  });

  // If we made any changes, trigger the variant change process
  if (needsUpdate && lastChangedInput) {
    // For auto-selection on page load, we still need to trigger the change event
    // to ensure proper cascading of option availability
    console.log('Auto-selection triggered, dispatching change event');

    // Trigger change event on the last changed input to cascade updates
    const changeEvent = new Event('change', { bubbles: true });
    lastChangedInput.dispatchEvent(changeEvent);
  }
}

function updateButtonState() {
  // Handle multiple product elements (main page + popover)
  const allProductElements = Array.from(document.querySelectorAll('#product'));

  allProductElements.forEach((productElement, index) => {
    const isPopover = productElement.closest('.product-popover');
    console.log(`Updating button state for product element ${index}:`, isPopover ? 'popover' : 'main-page');

    // Find the submit button associated with this product element
    let submitButton;
    if (isPopover) {
      // For popover, look for the submit button within the popover
      submitButton = productElement
        .closest('.product-popover')
        .querySelector('product-form.product-form [type="submit"]');
    } else {
      // For main page, use the general selector
      submitButton = document.querySelector('product-form.product-form [type="submit"]');
    }

    const submitButtonText = submitButton?.querySelector('span');

    if (!submitButton) {
      console.log(`No submit button found for product element ${index}`);
      return;
    }

    // Check if this is a single variant product
    const defaultVariantInput = productElement.querySelector('input[id$="-default-variant"]');
    let selectedInputWithVariant;

    if (defaultVariantInput) {
      selectedInputWithVariant = defaultVariantInput;
    } else {
      // Look for selected variant within this specific product element
      selectedInputWithVariant = productElement.querySelector('input[type="radio"]:checked[data-variant-id]');
    }

    if (selectedInputWithVariant) {
      const isAvailable = selectedInputWithVariant.dataset.available === 'true';

      // Don't override the quantity limit logic - only update if not already disabled for other reasons
      const currentlyDisabled = submitButton.hasAttribute('disabled');
      const currentText = submitButtonText?.textContent?.trim();

      // Check if button is disabled due to quantity limits (preserve that state)
      const isLimitReached = currentText === (window.variantStrings?.inCart || 'In Cart');

      if (!isLimitReached) {
        submitButton.disabled = !isAvailable;

        if (submitButtonText) {
          if (isAvailable) {
            submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
          } else {
            submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        }
      }

      console.log(
        `Updated button state for element ${index}: available=${isAvailable}, disabled=${submitButton.disabled}`,
      );
    } else {
      // No variant selected, disable button (but don't override quantity limit state)
      const currentText = submitButtonText?.textContent?.trim();
      const isLimitReached = currentText === (window.variantStrings?.inCart || 'In Cart');

      if (!isLimitReached) {
        submitButton.disabled = true;
        if (submitButtonText) {
          submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
        }
      }

      console.log(`No variant selected for element ${index}, button disabled`);
    }
  });
}

function attachVariantChangeListeners() {
  const optionInputs = document.querySelectorAll('#product .optionValueSelectors input[type="radio"]');
  optionInputs.forEach((input) => {
    input.addEventListener('change', onVariantChange);
  });
}

// Product Form Submission Handler - works with existing buy-buttons form
function handleProductFormSubmission() {
  // Find all product forms on the page (main page + popover)
  const productForms = document.querySelectorAll('product-form.product-form');

  productForms.forEach((productForm, index) => {
    const isPopover = productForm.closest('.product-popover');
    console.log(`Setting up form submission for form ${index}:`, isPopover ? 'popover' : 'main-page');

    const form = productForm?.querySelector('form[data-type="add-to-cart-form"]');
    const submitButton = form?.querySelector('[type="submit"]');
    const submitButtonText = submitButton?.querySelector('span');
    const loadingSpinner = submitButton?.querySelector('.loading-overlay__spinner, .loading__spinner');

    if (!form || !submitButton) {
      console.log(`Product form or submit button not found for form ${index}`);
      return;
    }

    // Remove any existing event listeners to prevent duplicates
    const newForm = form.cloneNode(true);
    form.parentNode.replaceChild(newForm, form);

    // Re-get references after cloning
    const newSubmitButton = newForm.querySelector('[type="submit"]');
    const newSubmitButtonText = newSubmitButton?.querySelector('span');
    const newLoadingSpinner = newSubmitButton?.querySelector('.loading-overlay__spinner, .loading__spinner');

    newForm.addEventListener('submit', function (evt) {
      evt.preventDefault();

      // Prevent double submission
      if (newSubmitButton.getAttribute('aria-disabled') === 'true' || newSubmitButton.hasAttribute('disabled')) {
        return;
      }

      // Show loading state
      newSubmitButton.setAttribute('aria-disabled', 'true');
      newSubmitButton.classList.add('loading');
      if (newLoadingSpinner) {
        newLoadingSpinner.classList.remove('hidden');
      }

      // Prepare form data using the same pattern as existing product-form.js
      const formData = new FormData(newForm);

      // Use the same fetchConfig pattern as the existing code
      const config = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript',
        },
      };

      // Set X-Requested-With header and remove Content-Type for FormData
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      // Submit to cart
      fetch(window.routes.cart_add_url, config)
        .then((response) => {
          // Check if the request was successful (200-299 status codes)
          if (response.ok) {
            // Check if response is JSON
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
              return response.json();
            } else {
              // If we get non-JSON response but status is OK, cart add likely succeeded
              // This happens when Shopify returns HTML instead of JSON
              console.log('Cart add successful but received HTML response');
              return { status: null, items: [] }; // Simulate successful response
            }
          } else if (response.status === 302 || response.redirected) {
            // Handle redirects as successful cart additions
            console.log('Cart add successful (redirect received)');
            return { status: null, items: [] };
          } else {
            // For other error status codes, try to parse as JSON for error details
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
              return response.json();
            } else {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
          }
        })
        .then((response) => {
          if (response.status) {
            // Handle errors
            console.error('Cart error:', response);
            const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
            const errorMessage = productForm.querySelector('.product-form__error-message');

            if (errorWrapper && errorMessage) {
              errorMessage.textContent = response.description || response.message || 'An error occurred';
              errorWrapper.removeAttribute('hidden');
            }

            // Update button to show sold out if that's the error
            if (response.description && response.description.includes('sold out')) {
              newSubmitButton.setAttribute('aria-disabled', 'true');
              if (newSubmitButtonText) {
                newSubmitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
              }
            }
            return;
          }

          // Success - show popover instead of redirecting
          showCartPopover();

          // Hide any error messages
          const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          if (errorWrapper) {
            errorWrapper.setAttribute('hidden', '');
          }

          // If this was submitted from a popover, close the popover
          if (isPopover) {
            const popover = productForm.closest('.product-popover');
            if (popover && popover.hidePopover) {
              popover.hidePopover();
            }
          }
        })
        .catch((error) => {
          console.error('Cart submission error:', error);

          // Check if the error is just a response format issue but cart add might have succeeded
          if (error.message.includes('Non-JSON') || error.message.includes('Unexpected token')) {
            console.log('Response format error, but item may have been added to cart. Showing success.');
            // Assume success and show popover since item was likely added
            showCartPopover();

            // If this was submitted from a popover, close the popover
            if (isPopover) {
              const popover = productForm.closest('.product-popover');
              if (popover && popover.hidePopover) {
                popover.hidePopover();
              }
            }
            return;
          }

          // Show error for genuine failures
          const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
          const errorMessage = productForm.querySelector('.product-form__error-message');

          if (errorWrapper && errorMessage) {
            errorMessage.textContent = 'There was an issue adding to cart. Please try again.';
            errorWrapper.removeAttribute('hidden');
          }
        })
        .finally(() => {
          // Reset loading state
          newSubmitButton.classList.remove('loading');
          newSubmitButton.removeAttribute('aria-disabled');
          if (newLoadingSpinner) {
            newLoadingSpinner.classList.add('hidden');
          }
        });
    });
  });
}

// Cart Popover Function
function showCartPopover() {
  const productElement = document.querySelector('#product');

  // Get product title - target the specific product title element
  const title =
    document.querySelector('h1.page--title')?.textContent ||
    document.querySelector('.page--title')?.textContent ||
    document.querySelector('h1')?.textContent ||
    '';

  // Get currently selected options dynamically
  let optionText = '';

  // Check if this is a single variant product
  const defaultVariantInput = productElement.querySelector('input[id$="-default-variant"]');
  if (defaultVariantInput) {
    // Single variant product - no options to display
    optionText = '';
  } else {
    // Multi-variant product - get selected options
    const selectedOptions = [];
    const fieldsets = productElement.querySelectorAll('.optionValueSelectors fieldset');

    fieldsets.forEach((fieldset) => {
      const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
      if (checkedInput && !checkedInput.disabled) {
        selectedOptions.push(checkedInput.value);
      }
    });

    optionText = selectedOptions.join(' / ');
  }

  // Get variant data for image
  let variant = null;
  const variantScript = document.querySelector('[data-selected-variant]');
  if (variantScript) {
    try {
      variant = JSON.parse(variantScript.textContent);
    } catch (e) {
      console.error('Error parsing variant data:', e);
    }
  }

  // Get image (90x90) - improved fallback logic
  let imageUrl = '';

  // First try variant featured image
  if (variant && variant.featured_image) {
    imageUrl = variant.featured_image.src.replace(/(\.[a-z]+)$/, '_90x90$1');
  }
  // Then try variant image (alternative property name)
  else if (variant && variant.image) {
    imageUrl = variant.image.replace(/(\.[a-z]+)$/, '_90x90$1');
  }
  // Fallback to product images from the page
  else {
    // Try multiple selectors for product images
    const productImage =
      document.querySelector('.product-image-wrapper img') || // Main product page
      document.querySelector('picture img') || // Sidebar or main product
      document.querySelector('.product__media img') || // Generic product media
      document.querySelector('#product img') || // Any image in product section
      document.querySelector('main img'); // Last resort - any main image

    if (productImage) {
      imageUrl = productImage.src;
      // Resize to 90x90 if it's a Shopify CDN image
      if (imageUrl.includes('cdn.shopify.com')) {
        imageUrl = imageUrl.replace(/(\.[a-z]+)(\?.*)?$/, '_90x90$1$2');
      }
    }
  }

  // Populate popover
  const popoverTitle = document.getElementById('popover-title');
  const popoverOption = document.getElementById('popover-option');
  const popoverImage = document.getElementById('popover-image');

  if (popoverTitle) popoverTitle.textContent = title;
  if (popoverOption) {
    popoverOption.textContent = optionText;
    // Hide the option text if there are no options (single variant)
    popoverOption.style.display = optionText ? 'block' : 'none';
  }
  if (popoverImage && imageUrl) {
    popoverImage.src = imageUrl;
    popoverImage.alt = title;
  }

  console.log('Popover data:', { title, optionText, imageUrl });

  // Show the popover
  const popover = document.getElementById('cart-popover');
  if (popover) {
    if (popover.showPopover) {
      popover.setAttribute('open', '');
      popover.showPopover();
    } else {
      popover.setAttribute('open', '');
      popover.style.display = 'block';
    }

    // Hide the popover after 3 seconds
    setTimeout(() => {
      if (popover.hidePopover) {
        popover.removeAttribute('open');
        popover.hidePopover();
      } else {
        popover.removeAttribute('open');
        popover.style.display = 'none';
      }
    }, 3000);
  }
}

// Make functions globally available
window.attachVariantChangeListeners = attachVariantChangeListeners;
window.ensureValidSelection = ensureValidSelection;
window.ensureValidSelectionOnLoad = ensureValidSelectionOnLoad;
window.updateVariantSelection = updateVariantSelection;
window.updateButtonState = updateButtonState;
window.handleProductFormSubmission = handleProductFormSubmission;
window.onVariantChange = onVariantChange;
window.showCartPopover = showCartPopover;

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function () {
  attachVariantChangeListeners();
  ensureValidSelectionOnLoad();
  updateVariantSelection();
  updateButtonState();
  handleProductFormSubmission();
});
